import { collection, addDoc, getDocs, query, orderBy, limit, startAfter } from "firebase/firestore"; 
import { firebaseStore } from "util/firebaseUtil";

export const addDocument = async () => {
    try {
        const docRef = await addDoc(collection(firebaseStore, "users"), {
          first: "Ada",
          last: "Lovelace",
          born: 1815
        });
        // console.log("Document written with ID: ", docRef.id);
      } catch (e) {
        console.error("Error adding document: ", e);
      }
}

export const readDocument = async () => {
    const querySnapshot = await getDocs(collection(firebaseStore, "users"));
    querySnapshot.forEach((doc) => {
        // console.log(`${doc.id} => ${doc.data().born}`);
    });
}

export const placeMapReadDocument = async (keyword: string) => {
  return await getDocs(collection(firebaseStore, keyword));
}
